import React from 'react';
import { Link } from 'react-router-dom';
import '../estilo.css';

export default function Inicio() {
  return (
    <div>
      {/* HERO / TOPO */}
      <div
        className="jumbotron text-center"
        style={{
          background:
            'radial-gradient(circle at top, #61527a 0%, #443c56 52%, #322943 100%)',
          padding: '80px 20px 70px',
        }}
      >
        <div style={{ maxWidth: '1120px', margin: '0 auto' }}>
          <div className="row" style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
            <div className="col-sm-6" style={{ marginBottom: '20px' }}>
              <div
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '10px',
                  padding: '8px 14px',
                  borderRadius: '999px',
                  background: 'rgba(255,255,255,0.08)',
                  border: '1px solid rgba(255,255,255,0.12)',
                  color: '#d7fff7',
                  fontSize: '13px',
                  fontWeight: 700,
                  letterSpacing: '0.3px',
                  marginBottom: '20px',
                }}
              >
                <span
                  style={{
                    width: '8px',
                    height: '8px',
                    borderRadius: '50%',
                    background: '#42a89c',
                    boxShadow: '0 0 10px rgba(66,168,156,0.6)',
                  }}
                />
                Ecossistema Quantum Trades para MetaTrader 5
              </div>

              <h1
                style={{
                  fontSize: '46px',
                  lineHeight: 1.1,
                  margin: '0 0 14px 0',
                  color: '#ffffff',
                  textAlign: 'left',
                }}
              >
                Quantum Trades
              </h1>

              <h3
                style={{
                  fontSize: '24px',
                  fontWeight: 500,
                  color: '#d8d1ff',
                  margin: '0 0 20px 0',
                  textAlign: 'left',
                }}
              >
                Três robôs, mais possibilidades de operação, análise e diversificação.
              </h3>

              <p
                style={{
                  maxWidth: '620px',
                  margin: 0,
                  fontSize: '17px',
                  lineHeight: 1.7,
                  color: '#f3f1ff',
                  textAlign: 'left',
                  paddingTop: 0,
                }}
              >
                A Quantum Trades reúne soluções diferentes para perfis diferentes de trader:
                o <strong>Quantum Trades EA</strong> para automação avançada e flexível,
                o <strong>QuantumTrades Bias</strong> para leitura de viés e direção de mercado,
                e o <strong>QuantumTrades Ragnarok</strong> para operações mais rápidas scalp.
              </p>

              <p
                style={{
                  maxWidth: '620px',
                  marginTop: '14px',
                  fontSize: '15px',
                  lineHeight: 1.7,
                  color: '#e5ddff',
                  textAlign: 'left',
                }}
              >
                Use robôs individuais ou combine estratégias para buscar mais equilíbrio,
                mais controle operacional e uma estrutura mais diversificada dentro do MT5.
              </p>

              <div
                style={{
                  marginTop: '26px',
                  display: 'flex',
                  gap: '12px',
                  flexWrap: 'wrap',
                  justifyContent: 'flex-start',
                }}
              >
                <Link to="/cadastro" className="btn btn-primary btn-lg">
                  Criar minha conta
                </Link>
                <Link to="/planos" className="btn btn-default btn-lg">
                  Ver planos e simular
                </Link>
              </div>

              <div
                style={{
                  marginTop: '22px',
                  display: 'flex',
                  gap: '22px',
                  flexWrap: 'wrap',
                  justifyContent: 'flex-start',
                }}
              >
                <div style={{ textAlign: 'left' }}>
                  <div style={{ color: '#42a89c', fontSize: '24px', fontWeight: 800 }}>3</div>
                  <div style={{ color: '#d8d1ff', fontSize: '13px' }}>Robôs disponíveis</div>
                </div>
                <div style={{ textAlign: 'left' }}>
                  <div style={{ color: '#42a89c', fontSize: '24px', fontWeight: 800 }}>MT5</div>
                  <div style={{ color: '#d8d1ff', fontSize: '13px' }}>Compatível com MetaTrader 5</div>
                </div>
                <div style={{ textAlign: 'left' }}>
                  <div style={{ color: '#42a89c', fontSize: '24px', fontWeight: 800 }}>Forex + Ouro</div>
                  <div style={{ color: '#d8d1ff', fontSize: '13px' }}>Estratégias para cenários diferentes</div>
                </div>
              </div>
            </div>

            <div className="col-sm-6 text-center">
              <div
                style={{
                  position: 'relative',
                  maxWidth: '500px',
                  margin: '0 auto',
                  padding: '26px',
                  borderRadius: '28px',
                  background: 'rgba(255,255,255,0.06)',
                  border: '1px solid rgba(255,255,255,0.10)',
                  boxShadow:
                    '0 24px 60px rgba(0,0,0,0.28), inset 0 1px 0 rgba(255,255,255,0.06)',
                  backdropFilter: 'blur(6px)',
                }}
              >
                <div
                  style={{
                    position: 'absolute',
                    inset: '18px',
                    borderRadius: '22px',
                    background:
                      'radial-gradient(circle at top right, rgba(66,168,156,0.14), transparent 42%), radial-gradient(circle at bottom left, rgba(132,110,143,0.18), transparent 40%)',
                    pointerEvents: 'none',
                  }}
                />

                <div
                  style={{
                    position: 'relative',
                    borderRadius: '22px',
                    padding: '18px',
                    background: 'linear-gradient(180deg, rgba(255,255,255,0.05), rgba(255,255,255,0.02))',
                  }}
                >
                  <img
                    src={require('../img/Quantum1.png')}
                    alt="Quantum Trades"
                    className="responsive-image"
                    style={{
                      maxWidth: '100%',
                      width: '100%',
                      height: 'auto',
                      display: 'block',
                      borderRadius: '18px',
                      boxShadow: '0 14px 35px rgba(0,0,0,0.22)',
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* SEÇÃO SOBRE / ID PARA O MENU */}
      <div id="about" className="container-fluid bg-quant">
        <div className="row">
          <div className="col-sm-7">
            <h2>O que é a Quantum Trades?</h2>
            <p>
              A <strong>Quantum Trades</strong> é uma estrutura de robôs para MetaTrader 5
              voltada para automação, leitura de mercado e apoio à execução de estratégias.
              Hoje a plataforma conta com <strong>três soluções diferentes</strong>, permitindo
              que cada trader escolha o modelo que faz mais sentido para sua rotina e seu perfil.
            </p>

            <p>
              Em vez de depender de uma única abordagem, você pode trabalhar com um conjunto
              mais diversificado de ferramentas: usar um robô específico, combinar dois, ou
              montar um pacote completo com propostas complementares para análise e operação.
            </p>

            <h3>Conheça os 3 robôs da Quantum Trades</h3>
            <ul>
              <li>
                <strong>Quantum Trades EA:</strong> robô principal da plataforma, com foco em
                automação avançada, múltiplos indicadores, correlação entre ativos, reentradas
                e gestão mais flexível para Forex.
              </li>
              <li>
                <strong>QuantumTrades Bias:</strong> solução voltada para leitura de viés e
                direção de mercado, ajudando na identificação de tendências e na construção de
                cenários mais claros.
              </li>
              <li>
                <strong>QuantumTrades Ragnarok:</strong> robô com proposta mais agressiva e
                dinâmica, especializado em operações rápidas no ouro (XAUUSD).
              </li>
            </ul>

            <h3>Nossa missão: tornar a automação mais acessível e mais completa</h3>
            <p>
              A Quantum Trades nasceu com a proposta de oferecer tecnologia acessível para quem
              quer operar com mais organização e menos improviso. Nosso foco não é vender uma
              promessa irreal, e sim entregar ferramentas que ajudem o trader a estruturar
              melhor sua operação.
            </p>

            <p>
              Com três robôs diferentes, conseguimos ampliar as possibilidades de uso:
              mais liberdade para testar, mais opções de combinação e uma visão mais completa
              para quem deseja montar uma operação com <strong>mais diversificação</strong>.
            </p>

            <h3>Por que isso é importante na prática?</h3>
            <ul>
              <li>
                <strong>Mais de uma abordagem operacional:</strong> você não fica preso a um
                único estilo de robô ou a uma única leitura de mercado.
              </li>
              <li>
                <strong>Mais possibilidades de diversificação:</strong> diferentes robôs podem
                ser usados para cenários diferentes, reduzindo a dependência de uma única lógica.
              </li>
              <li>
                <strong>Mais flexibilidade para evoluir:</strong> você pode começar com um
                robô e depois expandir para outros conforme sua necessidade.
              </li>
              <li>
                <strong>Mais clareza na contratação:</strong> agora é possível escolher robôs
                individuais ou optar pelo pacote completo com melhor custo-benefício.
              </li>
              <li>
                <strong>Mais alinhamento com o seu perfil:</strong> alguns traders preferem
                automação mais ampla, outros preferem leitura de viés, e outros buscam rapidez
                operacional em ativos específicos.
              </li>
            </ul>

            <h3>Uma estrutura pensada para crescer junto com o trader</h3>
            <p>
              Você pode utilizar nossos robôs de forma simples no início e, conforme ganhar
              confiança e experiência, montar uma estrutura mais completa. A ideia é que a
              Quantum Trades acompanhe essa evolução com ferramentas que façam sentido em
              diferentes fases da jornada.
            </p>

            <p>
              Em resumo: não somos mais apenas um único robô. Hoje a Quantum Trades é um
              <strong> ecossistema com mais opções, mais flexibilidade e mais diversificação</strong>
              para quem quer operar com tecnologia no MT5.
            </p>
          </div>

          <div className="col-sm-5 text-center">
            <div style={{ marginBottom: '20px' }}>
              <img
                src={require('../img/Quantum2.png')}
                alt="Quantum Trades Interface"
                className="responsive-image"
                style={{ maxWidth: '320px', height: 'auto' }}
              />
            </div>
            <div>
              <img
                src={require('../img/MetaTrader5.png')}
                alt="MetaTrader 5"
                className="responsive-image"
                style={{ maxWidth: '280px', height: 'auto', marginTop: '10px' }}
              />
              <p style={{ marginTop: '10px' }}>
                Compatível com plataformas que utilizam o <strong>MetaTrader 5</strong>.
              </p>
            </div>
          </div>
        </div>

        <div className="row" style={{ marginTop: '30px' }}>
          <div className="col-sm-12 text-center">
            <h3>Escolha o robô ideal ou combine estratégias</h3>
            <p>
              Agora você pode contratar de forma individual ou montar um pacote com os 3 robôs,
              de acordo com a sua necessidade, seu capital e sua forma de operar.
            </p>
            <p>
              O objetivo é simples: oferecer mais possibilidades para que você monte uma operação
              mais inteligente, mais organizada e com maior potencial de diversificação.
            </p>
            {/* FIX: era <a to="/planos"> que não funciona — agora usa Link corretamente */}
            <Link to="/planos" className="btn btn-primary btn-lg">
              Ver planos e começar
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
